import { logDebug } from '../logger';

export const logReceivedEvent = <T extends Event>(event: T) => logDebug(`Received ${event.type} event:\n\t`, event);
